import React, { useEffect, useState } from 'react';
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate';
import { FaEllipsisH, FaPlusCircle } from 'react-icons/fa';
import CreateVirtualWallet from './CreateVirtualWallet';
import { ColumnVirtualWallets, VirtualWalletsData } from '../../../types/TablesTypes/VirtualWallet';
import { Dropdown } from 'flowbite-react';
import showToast from '../../../components/CustomToast/toastHelper';
import client from '../../../api/client';

const VirtualAccount = () => {
  const [virtualAccounts, setVirtualAccounts] = useState<any>(null);
  const [tableRow, setTableRow] = useState<VirtualWalletsData[]>([]);
  const [filters, setFilters] = useState({
    fromDate: '',
    toDate: ''
  });
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await fetchVirtualAccounts();
      setLoading(false)
    };
    fetchData();
  }, [filters, currentPage]);

  const fetchVirtualAccounts = async () => {
    try {
      const apiUrl = '/subsidiary/view/static/accounts';
      const params = new URLSearchParams({
        ...filters,
        page: currentPage.toString(),
      }).toString();
      const response = await client.get(`${apiUrl}?${params}`);

      setVirtualAccounts(response.data.data);
      setTotalPages(response.data.data.page.totalPage);
      setTableRow(dataVirtualWallets());
      const message = response?.data?.message;

    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        const message = err?.response?.data?.message;
        console.error('Error getting data', err);
        showToast(message, "error");
      }
    }
  };

  const dataVirtualWallets = () => {
    const tempArr: VirtualWalletsData[] = [];
    virtualAccounts?.items
      ?.slice(0)
      .reverse()
      .forEach((virtualWallet: any) => {
        tempArr.push({
          accountName: virtualWallet?.accountName,
          accountNumber: virtualWallet?.accountNumber,
          bankName: virtualWallet?.bankName,
          bvn: virtualWallet?.bvn,
        });
      });
    return tempArr;
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div>
      <DashboardPagesTemplate
        apiUrl='/subsidiary/view/static/accounts'
        title='Virtual Accounts'
        onFilterChange={setFilters}
        headings={ColumnVirtualWallets}
        exportButtonExists={true}
        ctaButtonExists={true}
        buttonLabel='Create Virtual Account'
        buttonIcon={<FaPlusCircle />}
        showSearch={false}
        filters={filters}
        data={tableRow}
        dropdownItems={[]}
        datepickerExists={true}
        children={<CreateVirtualWallet />}
        emptyMessage='You currently do not have any virtual accounts'
        // onPageChange={handlePageChange} // Ensure this function is passed if DashboardPagesTemplate handles page changes
      />
    </div>
  );
};

export default VirtualAccount;
